import { useState } from 'react';
import { selectionProcessesAdmin } from '@/services/selectionProcesses';
import { Button } from '@/components/ui/button';

function downloadBlob(response, fallbackName) {
  const blob = response.data;
  const dispo = response.headers?.['content-disposition'] || '';
  const m = dispo.match(/filename="([^"]+)"/);
  const name = m ? m[1] : fallbackName;
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
}

export default function ExportButtons({ processId, slug, filters }) {
  const [downloading, setDownloading] = useState(null);

  const handle = async kind => {
    if (downloading) return;
    setDownloading(kind);
    try {
      const fn = kind === 'csv' ? selectionProcessesAdmin.exportCsv : selectionProcessesAdmin.exportXlsx;
      const ext = kind === 'csv' ? 'csv' : 'xlsx';
      const res = await fn(processId, filters);
      downloadBlob(res, `inscritos-${slug}.${ext}`);
    } finally {
      setDownloading(null);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        size="sm"
        disabled={!!downloading}
        onClick={() => handle('csv')}
      >
        {downloading === 'csv' ? 'Exportando…' : 'CSV'}
      </Button>
      <Button
        variant="outline"
        size="sm"
        disabled={!!downloading}
        onClick={() => handle('xlsx')}
      >
        {downloading === 'xlsx' ? 'Exportando…' : 'Planilha (XLSX)'}
      </Button>
    </div>
  );
}
